const t = {
  name: "CreditcardStartPayment",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4.8,14h4v2h-4V14z"/>
		<path class="st0" d="M0,4v2h2.4C2.2,6.4,2,6.9,2,7.4l-1.3,9.1c-0.3,1.8,1.1,3.4,3,3.4h15.1c2,0,3.7-1.5,4-3.4L24,7.4l0,0
			C24.2,5.6,22.8,4,21,4H0z M5.9,6H21c0.6,0,1.1,0.5,1,1.1L21.7,9h-18l0.2-1.3C4.1,6.7,4.9,6,5.9,6z M3.5,11h18l-0.8,5.3
			c-0.1,1-1,1.7-2,1.7H3.6c-0.6,0-1.1-0.5-1-1.1L3.5,11z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as CreditcardStartPayment
};
